// CYCLESKIT THEME — theme.js
// MOBILE NAV géré exclusivement dans header.liquid — NE PAS réécrire ici

document.addEventListener('DOMContentLoaded', function() {

  // STICKY CTA
  var stickyCta = document.getElementById('stickyCta');
  if (stickyCta) {
    window.addEventListener('scroll', function() {
      stickyCta.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
  }

  // FAQ ACCORDION
  document.querySelectorAll('details.faq-item').forEach(function(detail) {
    detail.addEventListener('toggle', function() {
      if (detail.open) {
        document.querySelectorAll('details.faq-item').forEach(function(other) {
          if (other !== detail) other.removeAttribute('open');
        });
      }
    });
  });

  // SCROLL REVEAL
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity .5s ease, transform .5s ease';
      observer.observe(el);
    });
  }

  // REVIEW FORM
  var reviewForm = document.getElementById('reviewForm');
  if (reviewForm) {
    reviewForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = reviewForm.querySelector('.btn-submit');
      var successMsg = document.getElementById('successMsg');
      btn.textContent = 'Envoi en cours...';
      btn.disabled = true;
      setTimeout(function() {
        reviewForm.querySelectorAll('input, textarea').forEach(function(el) { el.value = ''; });
        if (successMsg) successMsg.style.display = 'block';
        btn.textContent = 'Soumettre mon avis →';
        btn.disabled = false;
      }, 1200);
    });
  }

  // IMAGE GALLERY
  var thumbs = document.querySelectorAll('.gallery-thumb');
  var mainImg = document.querySelector('.gallery-main img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImg.src = this.dataset.src;
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

});
